import PropTypes from 'prop-types'
import React from 'react'

import bindUpdate from '../../../../shared_components/BoundUpdate'
import {Cancel, Continue} from '../../../../shared_components/ButtonTypes'
import Forms from '../../../../shared_components/forms'
import ModalForm from '../../../../shared_components/ModalForm'
import modalWrapper from '../../../../shared_components/ModalWrapper'
import routerUtils from '../../../../lib/routerUtils'
import storePrototype from '../../../../shared_components/StorePrototype'
import {TextGutterMedium} from '../../../../dashboard/src/components/blocks/Texts'
import usePasswordValidation from '../../../../shared_components/hooks/usePasswordValidation'

import Container from '../../../../lib/Container'
import AccountSettingsActions from '../../actions/AccountSettingsActions'

import './changePassword.scss'

class ChangePasswordInner extends React.Component {
  constructor(props) {
    super(props)
    this.state = {passwordErrors: []}
  }

  async submit() {
    const data = this.refs.form.formData()

    if (this.refs.form.validate().length === 0) {
      // Check password against HIBP and weak password list before submitting
      const serverErrors = await this.props.validatePassword(data.password)
      if (serverErrors.length > 0) {
        this.setState({passwordErrors: [{name: 'password', errors: serverErrors}]})
        return
      }

      this.setState({passwordErrors: []})
      this.props.updating(() => {
        AccountSettingsActions.fetchAccountInformation(this.props.userId)
        this.context.modalClosed()
        routerUtils.setLocation(API_HOST)
      })
      AccountSettingsActions.changePassword(data, this.props.userId)
    }
    if (this.props.errors.length > 0)
      this.props.finished()
  }
  closeModal() {
    this.props.finished()
    this.context.closeModal()
  }

  render() {
    const errors = this.props.errors
    return (
      <section className='change-password'>
        <a onClick={this.context.showModal}>Change Password</a>
        <ModalForm visible={this.props.showModal} ref='form' title='Change Password' closer={this.closeModal.bind(this)}>
          <TextGutterMedium>
            Password must be a minimum of 12 characters. Consider using a memorable phrase or use a password manager to generate one.
          </TextGutterMedium>
          <TextGutterMedium>
            Once your password is updated you will be required to sign in again using your new password.
          </TextGutterMedium>
          <Forms.PasswordInput label='Current password' name='current_password' validator={Forms.Validators.required} />
          <Forms.Password label='Your new password' name='password' />
          { this.state.passwordErrors.length > 0 && <Forms.Errors errors={this.state.passwordErrors[0].errors} /> }
          { errors && errors.length > 0 && <Forms.Errors errors={this.props.errors[0].errors} /> }
          <div className='button-group'>
            <Continue onClick={this.submit.bind(this)} loading={this.props.processing || this.props.validating}>Update</Continue>
            <Cancel onClick={this.closeModal.bind(this)} />
          </div>
        </ModalForm>
      </section>
    )
  }
}

ChangePasswordInner.contextTypes = {
  showModal: PropTypes.func,
  closeModal: PropTypes.func,
  modalClosed: PropTypes.func
}

ChangePasswordInner.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string),
  finished: PropTypes.func,
  processing: PropTypes.bool,
  showModal: PropTypes.bool,
  updating: PropTypes.func,
  userId: PropTypes.string,
  validatePassword: PropTypes.func,
  validating: PropTypes.bool
}

const ChangePassword = props => {
  const {validatePassword, validating} = usePasswordValidation()
  return <ChangePasswordInner {...props} validatePassword={validatePassword} validating={validating} />
}

Container.registerStore('change_password', storePrototype(AccountSettingsActions.Types.DID_CHANGE_PASSWORD))
export default modalWrapper(bindUpdate(ChangePassword, 'change_password', 'message'))
